<div class="internal-header-bar">
  <a routerLink="/internal"><img src="../../assets/img/logo.png" alt="logo" /></a>

  <div class="internal-header-bar__nav">
    <a routerLink="/internal/dashboard" class="internal-header-bar__nav__link">
      <span class="material-icons">admin_panel_settings</span>
      Internal
    </a>
  </div>

  <div class="internal-header-bar__buttons">
    <!-- Internal: open dropdown menu -->
    <button
      class="internal-header-bar__buttons__button"
      [matMenuTriggerFor]="accountMenu"
    >
      <div
        class="internal-header-bar__buttons__button"
        *ngIf="userProfilePic; else noPhoto"
      >
        <img [src]="userProfilePic" alt="Profile Picture" />
      </div>
      <ng-template #noPhoto>
        <div class="internal-header-bar__buttons__button__icon">
          <span class="material-icons">account_circle</span>
        </div>
      </ng-template>
      My Account
    </button>
    <mat-menu #accountMenu="matMenu">
      <button mat-menu-item *ngIf="canAlias" (click)="openAliasPicker()">Alias User</button>
      <button mat-menu-item (click)="logout()">Log Out</button>
    </mat-menu>
  </div>
</div>
